import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentRegion,
  getOrderRegion,
  getRegionList,
  getRegions,
} from "../../store/order";
import { changedRegion } from "../../store/order/orderSlice";

function ShopRegionList({ shop }) {
  const regionList = useSelector(getRegions());
  const currentRegion = useSelector(getCurrentRegion());

  useEffect(() => {
    getAllRegionsList();
  }, []);
  const dispatch = useDispatch();
  const handleChangeRegion = (value) => {
    dispatch(changedRegion(value));
  };
  const getAllRegionsList = async () => {
    dispatch(getRegionList(shop));
  };
  return (
    <div className="w-full">
      <p className="shop-region-label">Выберите регион:</p>
      <div className="shop-region-list">
        {regionList?.map((reg) => (
          <button
            className={
              "shop-region-button " +
              (currentRegion === reg.cardRegionCd
                ? "shop-region-button-active"
                : "")
            }
            disabled={currentRegion === reg.cardRegionCd}
            key={reg.cardRegionCd}
            onClick={() => handleChangeRegion(reg.cardRegionCd)}
          >
            {reg.cardRegionCd} ( {reg.regionCaption} )
          </button>
        ))}
      </div>
    </div>
  );
}

export default ShopRegionList;
